import React from 'react';
import HeaderComponent from "../../component/base/header-component/HeaderComponent";
import FooterComponent from "../../component/base/footer-component/FooterComponent";
import OnboardButton from "../../component/base/onboard-button-component/OnboardButton";
import {firstCharacterUpper} from "../../util/CharacterUtil";
import MilesAndSmilesLoginComponent from "../../component/custom/MilesAndSmilesLoginComponent";

const LoginOfferPage = (props) => {
    const {t, navigate, user, flight} = props.props;

    const getHeaderContent = () => {
        if (flight.domestic) {
            return t('home.content_domestic');
        } else {
            if (user.business) {
                return t('home.content_business');
            } else {
                if (isQuotas(user.quotas))
                    return t('home.content_and_quota')
                return t('home.content');
            }
        }
    }

    const isQuotas = (quotas) => {
        return quotas !== null && (quotas.nonPurchase?.length > 0 || quotas.purchase?.length > 0 || quotas.favor?.length > 0);
    }

    return (
        <div>
            <HeaderComponent title={t('home.title') + " " + firstCharacterUpper(user?.name) + (user?.name ? ',' : '')}
                             content={getHeaderContent()} showBack/>

            <div className="content-root">

                <div className="onboard-tabslogin-line-top"></div>

                <MilesAndSmilesLoginComponent props={props.props} state={"loginOffer"}/>

                <OnboardButton outline label={t('login.sign_up_miles_smiles')}
                               onClick={() => navigate('/miles-and-smiles-register', {state: "offer"})}/>

            </div>

            <FooterComponent/>
        </div>
    );
};

export default LoginOfferPage;

